import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ICustomerUpdationRequestBody, ICustomerUpdationResponse } from "@/api_framework/api_modals/Users";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
// returns new created userId
export const useCustomerUpdationAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError, toastNotification } = useAPIUtils();
  const execute = useCallback(
    async (userId: string, formData: ICustomerUpdationRequestBody): Promise<string | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response: string = await axios
          .put(CUSTOMER_APIS?.UPDATE_CUSTOMER?.baseURL ?? "", formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
            params: { user_id: userId },
          })
          .then((res: AxiosResponse<ICustomerUpdationResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setLoading({
                  key: "isCustomerUpdateInProgress",
                  status: false,
                }),
              );
              toastNotification(`${formData.name} customer updated successfully.`);
              return res.data.data.user_id;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
      return null;
    },
    [],
  );
  return execute;
};
